import { paymentClient, useQuery } from "@trueskin-web/apis"

export const usePrimaryPaymentMethodHook = () => {
  const {
    data: { data: primaryPaymentMethod } = {},
    isFetching: isFetchingPrimaryPaymentMethod,
  } = useQuery("primaryPaymentMethod", paymentClient.getPrimaryPaymentMethod)

  return { primaryPaymentMethod, isFetchingPrimaryPaymentMethod }
}
